<template>
  <transition name="zoom">
    <div v-if="showing" class="modal-overlay-editar-comision">
      <div class="modal-content-editar-comision">
        <div class="header-m">
          <h4>Editar Comisión de {{ profesionalNombre }}</h4>
          <button @click="hideModal" class="close-button">&times;</button>
        </div>
        <div class="body-m">
          <div v-if="!profesionalIdLocal">
            <p>Cargando datos del profesional...</p>
          </div>
          <div v-else>
            <div class="mb-3">
              <label class="form-label">Tipo de Comisión:</label>
              <div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="editFlatRate" value="flat" v-model="editable_commission_type">
                  <label class="form-check-label" for="editFlatRate">Tasa Fija</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="editTieredCommission" value="tier" v-model="editable_commission_type">
                  <label class="form-check-label" for="editTieredCommission">Tramos de Comisión</label>
                </div>
              </div>
            </div>

            <div v-if="editable_commission_type === 'flat'" class="mb-3">
              <label for="editFlatCommissionRate" class="form-label">Tasa de Comisión Fija (0.0 - 1.0):</label>
              <input type="number" class="form-control" id="editFlatCommissionRate" v-model.number="editable_flat_commission_rate" step="0.01" min="0" max="1">
            </div>

            <div v-if="editable_commission_type === 'tier'">
              <h6>Tramos de Comisión:</h6>
              <div v-for="(tier, index) in editable_commission_tiers" :key="index" class="row mb-2 align-items-end">
                <div class="col-md-3">
                  <label class="form-label-sm d-block">Límite Superior:</label>
                  <input type="number" class="form-control form-control-sm" v-model.number="tier.threshold_upper" placeholder="Ej: 100000">
                </div>
                <div class="col-md-3">
                  <label class="form-label-sm d-block">Tasa (0.0-1.0):</label>
                  <input type="number" class="form-control form-control-sm" v-model.number="tier.rate" step="0.001" placeholder="Ej: 0.2">
                </div>
                <div class="col-md-4">
                  <label class="form-label-sm d-block">Descripción:</label>
                  <input type="text" class="form-control form-control-sm" v-model="tier.description" placeholder="Ej: Hasta 100,000 CLP">
                </div>
                <div class="col-md-2 text-end">
                  <button v-if="editable_commission_tiers.length > 1" @click="removeTier(index)" class="btn btn-danger btn-sm">Eliminar</button>
                </div>
              </div>
              <button @click="addTier" class="btn btn-success btn-sm mt-2 mb-3">Agregar Tramo</button>
            </div>
          </div>
          <div v-if="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>
        </div>
        <div class="footer-m">
          <button @click="hideModal" class="btn btn-secondary">Cancelar</button>
          <button @click="saveChanges" class="btn btn-primary" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Guardar Cambios
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ModalEditarComision',
  props: {
    // profesional: { // Original professional data, if needed for comparison or other info
    //   type: Object,
    //   default: () => null
    // }
  },
  data() {
    return {
      showing: false,
      loading: false,
      errorMessage: '',

      profesionalIdLocal: null,
      profesionalNombre: '',

      editable_commission_type: 'tier', // 'flat' or 'tier'
      editable_flat_commission_rate: 0,
      editable_commission_tiers: [],

      default_tiers: [ // Keep a copy of default structure for resetting if needed
        { rate: 0.2, description: "Up to 100,000 CLP", threshold_upper: 100000 },
        { rate: 0.175, description: "From 100,001 to 300,000 CLP", threshold_upper: 300000 },
        { rate: 0.15, description: "From 300,001 to 600,000 CLP", threshold_upper: 600000 },
        { rate: 0.125, description: "From 600,001 to 1,000,000 CLP", threshold_upper: 1000000 },
        { rate: 0.1, description: "Over 1,000,000 CLP", threshold_upper: 2000000 }
      ]
    };
  },
  computed: {
    validationError() {
      if (this.editable_commission_type === 'flat') {
        if (typeof this.editable_flat_commission_rate !== 'number' || this.editable_flat_commission_rate < 0 || this.editable_flat_commission_rate > 1) {
          return 'La tasa de comisión fija debe ser un número entre 0 y 1.';
        }
      } else if (this.editable_commission_type === 'tier') {
        if (!this.editable_commission_tiers || this.editable_commission_tiers.length === 0) {
          return 'Debe definir al menos un tramo de comisión.';
        }
        const sortedTiers = [...this.editable_commission_tiers].sort((a,b) => a.threshold_upper - b.threshold_upper);
        for (let i = 0; i < sortedTiers.length; i++) {
          const tier = sortedTiers[i];
          if (tier.threshold_upper === null || typeof tier.threshold_upper !== 'number' || tier.threshold_upper <= 0) {
            return `El límite superior del tramo ${i + 1} debe ser un número positivo.`;
          }
          if (tier.rate === null || typeof tier.rate !== 'number' || tier.rate < 0 || tier.rate > 1) { // Assuming rates are 0-1
            return `La tasa del tramo ${i + 1} debe ser un número entre 0 y 1.`;
          }
          if (!tier.description || tier.description.trim() === '') {
            return `La descripción del tramo ${i + 1} no puede estar vacía.`;
          }
          if (i > 0 && tier.threshold_upper <= sortedTiers[i-1].threshold_upper) {
            return `El límite superior del tramo ${i + 1} (${tier.threshold_upper}) debe ser mayor que el del tramo anterior (${sortedTiers[i-1].threshold_upper}).`;
          }
        }
      }
      return '';
    }
  },
  methods: {
    show(profesionalData) {
      this.errorMessage = '';
      this.loading = false;

      if (!profesionalData || !profesionalData.id) {
        this.errorMessage = "No se proporcionaron datos válidos del profesional.";
        this.showing = true; // Show to display error
        return;
      }

      this.profesionalIdLocal = profesionalData.id;
      this.profesionalNombre = `${profesionalData.nombre || ''} ${profesionalData.apellido || ''}`.trim();

      // Determine commission type and populate data
      // Assuming 'margen_captacion' is the flat rate and 'commission_tiers' holds tier data.
      // Backend should ideally provide a 'commission_type' field.
      // Inferring type: if commission_tiers is present and not empty, assume 'tier'. Otherwise, assume 'flat'.

      if (profesionalData.commission_tiers && Array.isArray(profesionalData.commission_tiers) && profesionalData.commission_tiers.length > 0) {
        this.editable_commission_type = 'tier';
        this.editable_commission_tiers = JSON.parse(JSON.stringify(profesionalData.commission_tiers)); // Deep copy
        this.editable_flat_commission_rate = 0; // Reset flat rate if type is tier
      } else if (typeof profesionalData.margen_captacion === 'number') {
        this.editable_commission_type = 'flat';
        this.editable_flat_commission_rate = profesionalData.margen_captacion;
        this.editable_commission_tiers = JSON.parse(JSON.stringify(this.default_tiers)); // Reset tiers to default if type is flat
      } else {
        // Default if no data or unclear
        this.editable_commission_type = 'tier';
        this.editable_flat_commission_rate = 0;
        this.editable_commission_tiers = JSON.parse(JSON.stringify(this.default_tiers));
         // Optionally set an error message if data is missing/ambiguous
        // this.errorMessage = "Datos de comisión incompletos o ambiguos. Mostrando configuración por defecto.";
      }

      this.showing = true;
    },
    hideModal() {
      this.showing = false;
      // Reset data if needed, or on next show
      this.profesionalIdLocal = null;
      this.profesionalNombre = '';
      this.errorMessage = '';
      this.loading = false;
    },
    addTier() {
      this.editable_commission_tiers.push({ threshold_upper: null, rate: null, description: '' });
    },
    removeTier(index) {
      if (this.editable_commission_tiers.length > 1) {
        this.editable_commission_tiers.splice(index, 1);
      }
    },
    async saveChanges() {
      this.errorMessage = '';
      const validationMsg = this.validationError;
      if (validationMsg) {
        this.errorMessage = validationMsg;
        return;
      }

      this.loading = true;
      try {
        const payload = {
          profesional_id: this.profesionalIdLocal,
          commission_type: this.editable_commission_type,
          // Ensure flat_commission_rate is a number, even if 0
          flat_commission_rate: this.editable_commission_type === 'flat' ? Number(this.editable_flat_commission_rate) : null,
          // Sort tiers before sending
          commission_tiers: this.editable_commission_type === 'tier' ? this.editable_commission_tiers.sort((a, b) => a.threshold_upper - b.threshold_upper) : null,
        };

        await axios.post(`${window.hostname}api/admin/update_profesional_commission`, payload);

        this.$emit('commission-updated');
        this.hideModal();
      } catch (error) {
        console.error("Error al guardar cambios de comisión:", error);
        this.errorMessage = (error.response && error.response.data && error.response.data.message) || "Error al guardar cambios.";
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    editable_commission_type(newType) {
      // When type changes, reset the other type's data or set sensible defaults
      if (newType === 'flat') {
        // If switching to flat, tiers might be reset or kept if user might switch back.
        // For now, let's not reset tiers, but ensure flat_rate is focus.
        if (this.editable_flat_commission_rate === null || typeof this.editable_flat_commission_rate !== 'number') {
             this.editable_flat_commission_rate = 0;
        }
      } else if (newType === 'tier') {
        // If switching to tier, and tiers are empty, populate with default.
        if (!this.editable_commission_tiers || this.editable_commission_tiers.length === 0) {
          this.editable_commission_tiers = JSON.parse(JSON.stringify(this.default_tiers));
        }
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay-editar-comision {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* High z-index */
}

.modal-content-editar-comision {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  width: 700px; /* Or max-width and some padding */
  max-width: 90%;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-content-editar-comision .header-m {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.modal-content-editar-comision .header-m h4{
    margin: 0;
}


.modal-content-editar-comision .body-m {
  overflow-y: auto;
  padding-right: 10px; /* For scrollbar */
  margin-bottom:15px;
}

.modal-content-editar-comision .footer-m {
  border-top: 1px solid #eee;
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

/* Form control consistency */
.form-control, .form-control-sm {
  border-radius: 0.25rem; /* Standard Bootstrap radius */
}
.btn {
  border-radius: 6px; /* Rounded buttons */
}
.btn-sm {
  border-radius: 4px; /* Slightly less rounded for sm buttons if desired */
}

/* Basic alert styling */
.alert {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

/* Styling for zoom transition */
.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-name: zoomEffect;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoomEffect {
  from {
    opacity: 0;
    transform: scale3d(0.9, 0.9, 0.9);
  }
  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
</style>
